const MaterialTypes_T = Object.freeze({
    Basic: 0,
    Lambert: 1,
    Phong: 2,
    PBR: 3,
    Points: 4,
    LineBasic: 5,
    Sprite: 6,
    IconHotspot: 7,
    Custom: 8
});

const MaterialTypeInfo = {};

for (const name in MaterialTypes_T) {
    const id = MaterialTypes_T[name];
    MaterialTypeInfo[id] = { name };
}

Object.freeze(MaterialTypeInfo);

export { MaterialTypes_T, MaterialTypeInfo };
